import { renderElement } from '@aibees/shared/utils/react';
import { Collapse, Divider, List } from '@mui/material';
import { memo, ReactNode, useCallback, useState } from 'react';
import { navVerticalConfig } from '../config';
import type { NavConfigProps, NavListProps, NavSectionProps } from '../types';
import NavList from './nav-list';
import { StyledGroupsWrapper, StyledSubheader } from './styles';

function NavSectionVertical({
  data,
  config,
  sx,
  component,
  header,
  prepend,
  footer,
  ...other
}: NavSectionProps) {
  return (
    <StyledGroupsWrapper className="StyledGroupsWrapper" sx={sx} {...other}>
      {component
        ? renderElement(component as any)
        : data?.map((group, index) => (
            <Group
              {...group}
              key={group.subheader || index}
              config={navVerticalConfig(config)}
              divider={index < data.length - 1}
            />
          ))}
    </StyledGroupsWrapper>
  );
}

export default memo(NavSectionVertical);

export type GroupProps = {
  subheader?: string;
  customSubheader?: ReactNode;
  items: NavListProps[];
  config: NavConfigProps;
  divider?: boolean;
  hidden?: boolean;
};

function Group({
  subheader,
  items,
  config,
  divider,
  customSubheader,
  hidden,
}: GroupProps) {
  const [open, setOpen] = useState(true);

  const handleToggle = useCallback(() => {
    setOpen((prev) => !prev);
  }, []);
  const renderContent = items.map((list) => (
    <NavList
      key={list.title + list.path}
      data={list}
      depth={1}
      hasChild={!!list.children}
      childCount={list.children?.length}
      config={config}
    />
  ));

  if (hidden) return null;

  return (
    <>
      <List disablePadding sx={config.listSx || { px: 2 }}>
        {subheader || customSubheader ? (
          <>
            <StyledSubheader disableGutters disableSticky config={config}>
              {customSubheader ?? subheader}
            </StyledSubheader>

            <Collapse in={open}>{renderContent}</Collapse>
          </>
        ) : (
          renderContent
        )}
      </List>
      {divider && <Divider />}
    </>
  );
}
